export function nameof<T>(key: keyof T) {
  return key;
}
